// services/base-api.service.ts

import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocalStorageUtil } from '../utils/local-storage.util';
import { ConfigService } from './config.service';
import { resolveBffUrl } from '../utils/bff-url-resolver.util';

@Injectable({
  providedIn: 'root',
})
export class BaseApiService {
  protected baseUrl: string;
  protected configService = inject(ConfigService);

  constructor(protected http: HttpClient) {
    const bffUrl = this.configService.getBffUrlIfLoaded() ?? '';
    if (!bffUrl.trim()) {
      console.error('❌ [BaseApiService] Parâmetro "bffUrl" ausente na configuração runtime. Sistema indisponível.');
      this.baseUrl = '';
      return;
    }

    this.baseUrl = `${resolveBffUrl(bffUrl, this.configService.isDebugEnabled())}/api`;
  }

  public getHttpClient(): HttpClient {
    return this.http;
  }

  public getBaseUrl(): string {
    return this.baseUrl;
  }

  /**
   * Retorna headers com Authorization: Bearer <token> se houver token salvo
   */
  protected getAuthHeaders(includeJsonContentType: boolean = true): HttpHeaders {
    let headers = new HttpHeaders();

    if (includeJsonContentType) {
      headers = headers.set('Content-Type', 'application/json');
    }

    try {
      const token = LocalStorageUtil.getAccessToken();
      if (token) {
        headers = headers.set('Authorization', `Bearer ${token}`);
      }
    } catch {}
    return headers;
  }

  protected get<T>(endpoint: string): Observable<T> {
    const url = `${this.baseUrl}${endpoint}`;
    return this.http.get<T>(url, { headers: this.getAuthHeaders() });
  }

  protected post<T>(endpoint: string, data?: any, includeJsonContentType: boolean = true): Observable<T> {
    const url = `${this.baseUrl}${endpoint}`;
    return this.http.post<T>(url, data, { headers: this.getAuthHeaders(includeJsonContentType) });
  }

  protected put<T>(endpoint: string, data: any): Observable<T> {
    const url = `${this.baseUrl}${endpoint}`;
    return this.http.put<T>(url, data, { headers: this.getAuthHeaders() });
  }
}
